
import React, { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

interface ProcessStepProps {
  number: string;
  title: string;
  description: string;
  icon?: React.ReactNode;
  image?: string;
  reversed?: boolean;
  className?: string;
}

export const ProcessStep: React.FC<ProcessStepProps> = ({
  number,
  title,
  description,
  icon,
  image,
  reversed = false,
  className,
}) => {
  const stepRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={stepRef}
      className={cn(
        "flex flex-col md:flex-row items-center gap-8 md:gap-16 py-16 fade-in",
        reversed && "md:flex-row-reverse",
        className
      )}
    >
      {image && (
        <div className="w-full md:w-1/2 glass-card overflow-hidden rounded-2xl">
          <img
            src={image}
            alt={title}
            className="w-full h-auto object-cover transform transition-transform duration-500 hover:scale-105"
          />
        </div>
      )}
      
      <div className="w-full md:w-1/2 space-y-4">
        <div className="flex items-center gap-4 mb-4">
          <div className="flex items-center justify-center bg-primary/10 text-primary w-12 h-12 rounded-full font-bold">
            {number}
          </div>
          {icon && <div className="text-primary">{icon}</div>}
        </div>
        
        <h3 className="text-2xl font-medium">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
      </div>
    </div>
  );
};
